const mediaItems = [
  {
    title: '鬼灭之刃 柱训练篇 PV',
    desc: '最终决战前的最后特训，炭治郎与柱们全力备战',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20anime%20visual%20with%20dramatic%20fire%20and%20water%20energy%20effects%2C%20dark%20and%20warm%20color%20contrast%2C%20cinematic%20wide%20composition%2C%20action%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20intense%20mood&width=800&height=450&seq=media-demon-slayer-pv&orientation=landscape',
    alt: '鬼灭之刃柱训练篇PV - 高清动漫在线观看',
    duration: '1:32',
  },
  {
    title: '葬送的芙莉莲 OP主题曲',
    desc: 'YOASOBI献唱主题曲，画面唯美每一帧都是壁纸',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20stylized%20anime%20landscape%20with%20soft%20golden%20sunlight%20through%20trees%2C%20magical%20particles%20floating%2C%20warm%20cream%20and%20green%20tones%2C%20fantasy%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20peaceful%20mood&width=800&height=450&seq=media-frieren-op&orientation=landscape',
    alt: '葬送的芙莉莲主题曲 - 番剧在线观看',
    duration: '1:30',
  },
  {
    title: '怪兽8号 战斗场面集锦',
    desc: '卡夫卡变身怪兽8号的震撼战斗场景全程高能',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20stylized%20anime%20action%20visual%20with%20explosive%20energy%20and%20cityscape%20background%2C%20teal%20and%20orange%20contrast%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20powerful%20mood&width=800&height=450&seq=media-kaiju-clip&orientation=landscape',
    alt: '怪兽8号战斗集锦 - 动漫网站在线看',
    duration: '2:45',
  },
  {
    title: '我推的孩子 第二季 预告',
    desc: '舞台剧篇开幕，新角色登场剧情进入全新篇章',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20anime%20stage%20performance%20visual%20with%20spotlights%20and%20sparkles%2C%20purple%20and%20pink%20gradient%2C%20showbiz%20atmosphere%2C%20glamorous%20composition%2C%20no%20text%2C%20no%20characters%2C%20dazzling%20mood&width=800&height=450&seq=media-oshi-no-ko-pv&orientation=landscape',
    alt: '我推的孩子第二季预告 - 最新动漫在线看',
    duration: '1:15',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            精彩片段
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            热门动漫精彩PV与片段集锦，快速感受每部番的魅力
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-200/60 transition-colors duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}